import RISK_RATING_LEVELS from '../../../../config/simm/default/risk_rating_levels.yml';

const SORTED_RISK_RATING_LEVELS = Object
  .entries(RISK_RATING_LEVELS)
  .sort(([a,], [b,]) => a - b);

export default function getRiskRatingLevel(riskRating) {
  for (let [key, value] of SORTED_RISK_RATING_LEVELS) {
    if (riskRating <= key) return value;
  }
  return 'n/a';
}
